import { createAsyncThunk } from '@reduxjs/toolkit'
import GameArtifact from './game-artifact-model'
import {
  delete_gameArtifact,
  load_gameArtifacts,
  store_gameArtifact,
} from './gameArtifact-service'

export const LoadGameArtifactsAsync = createAsyncThunk<any, any>(
  'composer/load/gameArtifact',
  async (params: { uid: string }) => {
    return await load_gameArtifacts(params)
  },
)

export const CreateGameArtifactAsync = createAsyncThunk<any, any>(
  'composer/create/gameArtifact',
  async (params: GameArtifact) => {
    return await store_gameArtifact(params)
  },
)

export const DeleteGameArtifactAsync = createAsyncThunk<any, any>(
  'composer/delete/gameArtifact',
  async (params) => {
    return await delete_gameArtifact(params)
  },
)
